export default "__VITE_ASSET__YWWuV3Ru__"